// hooks/useFinalPerformanceReport.ts
import { useEffect } from 'react';

import { getReportContext } from '../utils';

export const useFinalPerformanceReport = () => {
  useEffect(() => {
    const sendFinalReport = async () => {
      if (window?.__PERF_METRICS__?.isFinalSent) return;
      const { sessionId, requestUrl } = getReportContext();
      if (!sessionId) return;

      const metrics = [
        {
          /**
           * Shell Mount: Total time to download, parse, and start the React application.
           * If high: The JS bundle is too heavy for the user's device or bandwidth.
           * This is the moment when the "Skeleton" or "Loader" finally appears.
           */
          name: 'total_init_time',
          value: `${Math.round(performance.now())}`,
        },
      ];
      try {
        await fetch(requestUrl, {
          method: 'POST',
          mode: 'cors',
          headers: {
            'X-Session-Id': sessionId,
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            metrics,
            tags: {},
          }),
          keepalive: true,
        });
      } catch (e) {
        // Fail silently
      }
    };

    sendFinalReport().finally(() => {
      if (window.__PERF_METRICS__) {
        window.__PERF_METRICS__.isFinalSent = true;
      } else {
        window.__PERF_METRICS__ = {
          isFinalSent: true,
        };
      }
    });
  }, []);
};
